import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import Column from '../../shared/ui/Column';
import RoomsList from '../../controllers/RoomsList';
import ModelSearch from '../../controllers/ModelSearch';
import FilterBtn from '../../shared/ui/FilterBtn';
import { actionCreators, selectors, sliceKeys } from '../../model';
import RoomsListFilter from '../../controllers/RoomsListFilter';

const { selectHasHouses } = selectors[sliceKeys.houses];
const { selectSearch, selectHasFilter } = selectors[sliceKeys.rooms];
const { searchChanged } = actionCreators[sliceKeys.rooms];

const RoomsCol = () => (
  <Column title="Помещения">
    <Content />
  </Column>
);

export default RoomsCol;

const Content = () => {
  const hasHouses = useSelector(selectHasHouses);

  if (!hasHouses) {
    return (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Выберите дома" />
    );
  }

  return (
    <RoomsList>
      <div className="colFilterWrap">
        <ModelSearch selector={selectSearch} createAction={searchChanged} />
        <FilterBtnBlock />
      </div>
    </RoomsList>
  );
};

function FilterBtnBlock() {
  const hasFilter = useSelector(selectHasFilter);

  return <FilterBtn renderContent={renderFilter} isActive={hasFilter} />;
}

function renderFilter({ onClose }) {
  return <RoomsListFilter onClose={onClose} />;
}
